import { useState } from 'react';
import ExtendTrialModal from './modal';

interface ExtendTrialProps {
  onClose?: () => void;
}

export const useExtendTrialModal = ({ onClose = () => null }: ExtendTrialProps) => {
  const [open, setOpen] = useState(false);
  const closeModal = () => {
    setOpen(false);
    onClose();
  };
  const modalProps = { open, onClose: closeModal };

  return {
    onClick: () => setOpen(true),
    Modal: ExtendTrialModal,
    modalProps,
  };
};
